import {
  Component,
  ComponentFactoryResolver,
  OnInit,
  ViewContainerRef,
} from "@angular/core";
import {
  cacheReadyOperator,
  FlowNodeController,
} from "../../flow-node.controller";
import { FlowsService } from "../../flows.service";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { UiService } from "src/app/ui/ui.service";
import { MatDialog } from "@angular/material/dialog";
import { NotificationNodeMenuComponent } from "./notification-node-menu/notification-node-menu.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-notification-node",
  templateUrl: "./notification-node.component.html",
  styleUrls: ["./notification-node.component.scss"],
})
export class NotificationNodeComponent
  extends FlowNodeController
  implements OnInit
{
  constructor(
    factoryResolver: ComponentFactoryResolver,
    ViewContainerRef: ViewContainerRef,
    FlowsService: FlowsService,
    Router: Router,
    uiService: UiService,
    MatDialog: MatDialog,
  ) {
    super(
      factoryResolver,
      ViewContainerRef,
      FlowsService,
      Router,
      uiService,
      MatDialog,
    );
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();
    forkJoin([
      this.FlowsService.notificationCacheReady.pipe(cacheReadyOperator()),
    ])
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        const factory = this.factoryResolver.resolveComponentFactory(
          NotificationNodeMenuComponent,
        );
        this.menuComponent = factory.create(
          this.flowMenuViewContainerRef.parentInjector,
        );
        this.menuComponent.instance.node = this.node;
        this.menuComponent.instance.selected = this.selected;
        this.menuComponent.instance.onMenuSizeChange = this.onMenuSizeChange;

        this.flowMenuViewContainerRef.insert(this.menuComponent.hostView);
        this.menuComponent.instance.onNodeMenuInstantiated
          .pipe(takeUntil(this.onComponentDestroy))
          .subscribe(() => {
            this.onMenuInstantiated.next();
            this.onMenuInstantiated.complete();
            this.onNodeReady.emit(this.componentRef);
          });
      });

    this.FlowsService.initNotificationNodeCache();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
